import { Inject, Injectable } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { Definition, DefinitionCategory, Faq, FaqCategory, SharedConfig, SHARED_CONFIG } from '@emi/shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../http.service';

@Injectable({
    providedIn: 'root',
})
export class HelpResourcesService {
    constructor(@Inject(SHARED_CONFIG) private config: SharedConfig, private httpService: HttpService) {}

    public findCategoryDefinitions(categoryId: number, categoryTitle: string): Observable<DefinitionCategory> {
        return this.httpService
            .getHttp<Definition[]>(
                Constants.ServiceConstants.HELP_SERVICE_CATEGORY_DEFINITIONS,
                {
                    categoryIds: categoryId,
                },
                undefined,
                this.config.helpServiceUrl
            )
            .pipe(map((list: Array<any>) => list.map((cat) => new Definition(cat.id, cat.name, cat.definition))))
            .pipe(map((definitions) => new DefinitionCategory(99, `CATEGORIES > ${categoryTitle.toUpperCase()} `, definitions)));
    }

    public getDefinitions(): Observable<DefinitionCategory[]> {
        return this.httpService.getHttp<Array<DefinitionCategory>>(
            Constants.ServiceConstants.DEFINITIONS,
            undefined,
            undefined,
            this.config.helpServiceUrl
        );
    }

    public getFaqCategories(): Observable<Array<FaqCategory>> {
        return this.httpService.getHttp<Array<FaqCategory>>(
            Constants.ServiceConstants.HELP_SERVICE_FAQ_CATEGORIES,
            undefined,
            undefined,
            this.config.helpServiceUrl
        );
    }

    public getFaqs(): Observable<Array<Faq>> {
        return this.httpService.getHttp<Array<Faq>>(
            Constants.ServiceConstants.HELP_SERVICE_FAQS,
            undefined,
            undefined,
            this.config.helpServiceUrl
        );
    }
}
